import { useEffect } from 'react';
import settings from '@/content/settings.json';

const SCRIPT_ID = 'ld-localbusiness';

/**
 * Dati strutturati schema.org (JSON-LD) per Google/Google Maps — compilati
 * da admin, tab Impostazioni → "Dati attività". Se il nome o l'indirizzo
 * non sono ancora compilati non inietta nulla (dati incompleti sono peggio
 * di nessun dato per Google). Site-wide, non cambia per pagina.
 */
export function LocalBusinessSchema() {
  useEffect(() => {
    const b = settings.business;
    if (!b || !b.name || !b.streetAddress) return;

    const socialUrls = (settings.footer?.socials || []).map((s) => s.href).filter(Boolean);

    const data = {
      '@context': 'https://schema.org',
      '@type': 'CafeOrCoffeeShop',
      name: b.name,
      url: window.location.origin,
      image: b.image ? new URL(b.image, window.location.origin).href : undefined,
      address: {
        '@type': 'PostalAddress',
        streetAddress: b.streetAddress,
        postalCode: b.postalCode || undefined,
        addressLocality: b.city || undefined,
        addressRegion: b.region || undefined,
        addressCountry: b.country || 'IT',
      },
      telephone: b.phone || undefined,
      email: b.email || undefined,
      priceRange: b.priceRange || undefined,
      geo: (b.lat && b.lng) ? { '@type': 'GeoCoordinates', latitude: b.lat, longitude: b.lng } : undefined,
      openingHours: (b.openingHours || []).map((h) => `${h.days} ${h.opens}-${h.closes}`),
      sameAs: socialUrls.length > 0 ? socialUrls : undefined,
    };

    let el = document.getElementById(SCRIPT_ID);
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = SCRIPT_ID;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);

    return () => { document.getElementById(SCRIPT_ID)?.remove(); };
  }, []);

  return null;
}
